export default __webpack_public_path__ + "static/media/3WA.6f436692.jpg";